<template lang="pug">
.coupons-container(:class="`coupon-type-${type}`")
  .title {{ cardInfo.goodsPropDesc }}
  .money
    .number {{ cardInfo.cardMoney }}
    .unit {{ cardInfo.cardSign }}
  .desc(@click="openChangeModal(cardInfo)") {{cardInfo.couponWord}}
  changeExpansionCardModalContainer(
    v-if="showChangeModal"
    :show.sync="showChangeModal"
    :openChangeType="3"
    :couponInfo="changeValue"
    :unOpenCouponGameAB="unOpenCouponGameAB"
  )
</template>
<script>
import expansionCss from './expansion-css.vue';
import changeExpansionCardModalContainer from './change-expansion-card-modal.vue';

export default {
  components: {
    expansionCss,
    changeExpansionCardModalContainer,
  },
  props: {
    type: {
      type: String,
      default: '1',
    },
    isHaveExpanSion: {
      type: Boolean,
      default: false,
    },
    cardInfo: {
      type: Object,
      default: () => { },
    },
    unOpenCouponGameAB: {
      type: Boolean,
      default: false,
      required: false,
    },
    isnew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showChangeModal: false,
    };
  },
  computed: {
    newStyleBottom() {
      if (this.isHaveExpanSion) {
        return { background: 'url(https://m.hellobike.com/resource/gallery/43/XRRHhhi1_Group%20611%20(1)%20(1).png)' };
      }
      return '';
    },
  },
  methods: {
    openChangeModal(expandItem) {
      if (this.isHaveExpanSion) {
        this.changeValue = expandItem;
        this.showChangeModal = true;
      }
    },
    expansiveValue(value) {
      if (value && value.vipExtendProperty) {
        if (value.vipExtendProperty.propType === 4 || value.vipExtendProperty.propType === 7) {
          return value.vipExtendProperty.propTimes;
        }
        return value.vipExtendProperty.propAmount;
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.coupons-container {
  width: 0.78rem;
  height: 0.9rem;
  background-image: url(https://m.hellobike.com/resource/gallery/350/rtE91nr-_coupon-new-bg.png);
  background-repeat: no-repeat;
  background-size: 100%;

  .title {
    font-weight: 500;
    font-size: 0.11rem;
    line-height: 0.12rem;
    text-align: center;
    margin-top: 0.03rem;
    color: rgba(55, 59, 62, 1);
  }

  .money {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: end;
    margin-top: 0.1rem;
    height: 0.3rem;

    .number {
      height: 0.3rem;
      display: flex;
      align-items: center;
      // line-height: 0.29rem;
      font-family: "DIN Alternate", sans-serif;
      font-weight: 700;
      font-size: 0.26rem;
      color: rgba(250, 70, 20, 1);
    }

    .unit {
      height: 0.22rem;
      display: flex;
      align-items: center;
      margin-top: 0.1rem;
      margin-left: 0.03rem;
      font-weight: 400;
      font-size: 0.11rem;
      color: rgba(250, 70, 20, 1);
    }
  }

  .desc {
    width: 0.6rem;
    height: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.1rem auto 0;
    color: #fff;
    font-size: 0.12rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.coupon-type-2 {
    width: 0.6rem;
    min-width: 0.6rem;
    height: 0.61rem;
    background-image: url(https://m.hellobike.com/resource/gallery/350/zTTHunRQ_coupon-new-small-bg.png);
    background-repeat: no-repeat;
    background-size: 100%;
    margin-right: 0.06rem;

    .title {
      margin-top: 0.02rem;
      font-size: 0.1rem;
    }

    .money {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: end;
      margin-top: 0.02rem;
      height: 0.26rem;

      .number {
        height: 0.26rem;
        display: flex;
        align-items: center;
        font-family: "DIN Alternate", sans-serif;
        font-weight: 700;
        font-size: 0.22rem;
        color: rgba(250, 70, 20, 1);
      }

      .unit {
        height: 0.19rem;
        // display: flex;
        // align-items: center;
        // padding-top: 0.04rem;
        line-height: 0.21rem;
        margin-left: 0.02rem;
        font-weight: 400;
        font-size: 0.1rem;
        color: rgba(250, 70, 20, 1);
      }
    }

    .desc {
      color: rgba(177, 102, 82, 1);
      font-size: 0.1rem;
      margin: 0 auto 0;
    }
  }
}
</style>
